import { useTranslations } from 'next-intl'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Button,
  Text,
  Icon,
  HStack,
  useColorModeValue,
  Stack,
} from '@chakra-ui/react'
import { BsCpu } from 'react-icons/bs'

type Props = {
  isOpen: boolean
  onClose: () => void
}

export const FirmwareInfoModal = ({ isOpen, onClose }: Props) => {
  const t = useTranslations('hardware-list.firmware-modal')

  return (
    <Modal isOpen={isOpen} onClose={onClose} size={{ base: 'full', md: 'xl' }}>
      <ModalOverlay />
      <ModalContent
        bg={useColorModeValue('white', 'gray.940')}
        p="16px"
        maxW={{ base: '100%', md: '800px' }}
        borderRadius={{ base: '0', md: '8px' }}
        borderWidth={1}
        borderColor={useColorModeValue('blackAlpha.200', 'whiteAlpha.200')}
        my={{ base: 0, md: '0' }}
        mt={{ base: 0, md: '10' }}
      >
        <ModalBody
          p={0}
          display="flex"
          flexDirection="column"
          h={{ base: 'full', md: 'auto' }}
        >
          <Stack gap={{ base: '12px', md: '16px' }} flex={1}>
            <HStack
              bg={useColorModeValue('blackAlpha.50', 'whiteAlpha.50')}
              gap="16px"
              px="16px"
              py="20px"
              borderRadius="8px"
            >
              <Icon
                as={BsCpu}
                boxSize={{ base: '36px', md: '48px' }}
                flexShrink={0}
              />
              <Stack gap="8px">
                <Text fontSize={{ base: '18px', md: '24px' }} fontWeight="600">
                  {t('title')}
                </Text>
                <Text
                  fontSize={{ base: 'sm', md: 'md' }}
                  color={useColorModeValue('blackAlpha.800', 'whiteAlpha.800')}
                >
                  {t('subtitle')}
                </Text>
              </Stack>
            </HStack>
            <Text px="16px" fontSize={{ base: 'sm', md: 'md' }}>
              {t.rich('body', {
                br: () => <br />,
              })}
            </Text>
            <Button
              w="full"
              maxW={{ base: '100%', md: '256px' }}
              h="50px"
              mx={{ base: 0, md: '16px' }}
              mt={{ base: 'auto', md: 0 }}
              bg={useColorModeValue('blackAlpha.100', 'whiteAlpha.300')}
              _hover={{
                bg: useColorModeValue('blackAlpha.50', 'whiteAlpha.100'),
              }}
              onClick={onClose}
            >
              {t('cta')}
            </Button>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
